import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { WinAnimation } from '../components/WinAnimation';
import './CasinoDice.css';

export function CasinoDice() {
  const { gameState, placeBet, addBalance, setLastWin, recordSpin, betOptions } = useGame();
  const [dice, setDice] = useState<[number, number]>([1, 1]);
  const [rolling, setRolling] = useState(false);
  const [choice, setChoice] = useState<'over' | 'under' | null>(null);
  const [message, setMessage] = useState('');
  const [lastWin, setLastWinLocal] = useState(0);
  const [showWinAnim, setShowWinAnim] = useState(false);

  const canPlay = choice !== null && gameState.balance >= gameState.bet && !rolling;

  const play = useCallback(() => {
    if (!canPlay) return;
    const bet = gameState.bet;
    addBalance(-bet);
    setRolling(true);
    setMessage('');

    const duration = 1500;
    const start = Date.now();
    const rollInterval = setInterval(() => {
      setDice([
        Math.floor(Math.random() * 6) + 1,
        Math.floor(Math.random() * 6) + 1,
      ]);
      if (Date.now() - start > duration) {
        clearInterval(rollInterval);
        const d1 = Math.floor(Math.random() * 6) + 1;
        const d2 = Math.floor(Math.random() * 6) + 1;
        setDice([d1, d2]);
        const s = d1 + d2;
        const win = (choice === 'over' && s > 7) || (choice === 'under' && s < 7) ? bet * 2 : 0;
        if (s === 7) { addBalance(bet); setLastWinLocal(bet); setMessage('Tasapeli – panos palautettu'); }
        else if (win > 0) {
          setLastWin(win);
          setLastWinLocal(win);
          setMessage('Voitto!');
          setShowWinAnim(true);
          recordSpin(true);
        } else {
          setMessage('Häviö');
          recordSpin(false);
        }
        setRolling(false);
      }
    }, 120);
  }, [canPlay, choice, gameState.bet, addBalance, setLastWin, recordSpin]);

  return (
    <div className="casino-dice">
      {showWinAnim && lastWin > 0 && (
        <WinAnimation amount={lastWin} isBonus={false} onEnd={() => setShowWinAnim(false)} />
      )}
      <div className="casino-dice-container">
        <Link to="/" className="casino-back">← Takaisin</Link>
        <div className="casino-balance-bar">
          <span className="balance-value">€{gameState.balance}</span>
          <select value={gameState.bet} onChange={(e) => placeBet(Number(e.target.value))} disabled={rolling} className="bet-select">
            {betOptions.map((b) => (
              <option key={b} value={b}>€{b % 1 ? b.toFixed(1) : b}</option>
            ))}
          </select>
        </div>
        <h1 className="dice-title">🎲 Noppa</h1>
        <p className="dice-rules">Summa yli 7 vai alle 7? Voitto 2× panos (7 = tasapeli, panos palautuu)</p>
        <div className="dice-result">
          <span className="dice-die">{dice[0]}</span>
          <span className="dice-die">{dice[1]}</span>
        </div>
        <div className="dice-sum">Summa: {dice[0] + dice[1]}</div>
        {!rolling && (
          <div className="dice-choices">
            <button type="button" className={`dice-btn ${choice === 'over' ? 'active' : ''}`} onClick={() => setChoice('over')}>Yli 7</button>
            <button type="button" className={`dice-btn ${choice === 'under' ? 'active' : ''}`} onClick={() => setChoice('under')}>Alle 7</button>
          </div>
        )}
        <button type="button" className="spin-button" onClick={play} disabled={!canPlay}>
          {rolling ? 'Heitä...' : `Pelaa €${gameState.bet}`}
        </button>
        {message && <div className="slot-message">{message}</div>}
      </div>
    </div>
  );
}
